import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { IScheduleDetails } from '../../schedule/types/ISchedule';

// Keep this interface in-sync with ISchedule
export interface IUpdateScheduleParams {
  id: string;
  name: string;
  scheduleType: string; // Hourly, Daily, Weekly, Monthly
  scheduleDetails: IScheduleDetails;
  priority: number;
  parallel: boolean;
  enabledForLinkedTasks?: boolean;
}

export class UpdateScheduleRequest extends Request<IUpdateScheduleParams, IResult> {
  constructor(params: IUpdateScheduleParams) {
    super('updateSchedule', params);
  }
}
